/// <reference path="../../app.d.ts"/>
/// <reference path="../../../../../shared/utils/View.ts"/>

import { BasicApplicationRouter } from '../../../../../shared/services/BasicApplicationRouter';
import { BasicUserService } from '../../../../../shared/services/BasicUserService';
import { BasicApplicationService } from '../../../../../shared/services/BasicApplicationService';
import { AppPersistenceService } from "../services/AppPersistenceService";
import { AppViewService } from "../services/AppViewService";
import { User } from "../../../../../shared/models/api/User/User";
import { defaults } from '../defaults';
import { ApplicationPages } from '../Constants';

import { InputPageController } from './steps/InputPageController';
import { CheckPageController } from './steps/CheckPageController';
import { AppUtils } from '../../../../../shared/utils/index';

export class App implements AppController {
	private readonly loader: BasicLoader<MglAddMembersAppDefinition>;
	private readonly options: MglAddMembersAppOptions;
	private readonly $ctx: JQuery;
	private readonly applicationService: BasicApplicationService<MglAddMembersAppDefinition>;
	private readonly userService: BasicUserService<MglAddMembersAppDefinition>;
	private readonly applicationRouterService: BasicApplicationRouter<MglAddMembersAppDefinition>;
	private readonly appPersistenceService: AppPersistenceService;
	private readonly appViewService: AppViewService;
	private stepController: StepController;

	 
	constructor(element: HTMLElement, options: MglAddMembersAppOptions, loader: BasicLoader<MglAddMembersAppDefinition>) {
		this.loader = loader;
		this.options = $.extend(true, {}, defaults, options);
		this.$ctx = this.options.$ctx;

		// services
		this.applicationService = new BasicApplicationService(this.options);
		this.userService = new BasicUserService(this.options);
		this.applicationRouterService = new BasicApplicationRouter(this.options);
		this.appPersistenceService = new AppPersistenceService(this.options);
		this.appViewService = new AppViewService(this.options, loader);
	}

	public start(): void {
		this.callDependencyLoader();
	}

	public callDependencyLoader(): void {
		this.loader._loadDependencies(this.initApplication.bind(this));
	}

	public initApplication(): void {
		AppUtils.View.startLoader();
		this.appPersistenceService.prepareApplicationSession();
		this.userService.getUser((user: User) => {
			this._checkPreconditions(user, () => {
				if (this.appPersistenceService.getApplicationStepFromStore() === 1) {
					const options = this.applicationService.preparePageOptions(ApplicationPages.Check);
					this.stepController = new CheckPageController(this, options, this.loader, user);
					this.stepController.start();
				} else {
					this.stepController = new InputPageController(this, this.options, this.loader, user);
					this.stepController.start();
				}
			});
		});
	}

	private isPartnerAdvertising(): boolean {
		return this.options.app.ispartneradvertising;
	}

	private _checkPreconditions(user: User, callback: () => void): void {
		if (user.ValidMember) {
			callback();
		} else if (user.Valid) {
			this.applicationRouterService.error();
		} else {
			this.applicationRouterService.login();
		}
	}

	public afterRenderApp(): void {
		this.loader.initAdditionalModules(this.$ctx);
		AppUtils.View.stopLoader();

		if (this.isPartnerAdvertising()) {
			const partnerAdvertisingData = this.appPersistenceService.getPartnerAdvertisingDataFromStorage();
			if (partnerAdvertisingData) {
				const friendsadvertisinglogouturl = this.options.app.partneradvertisinglogouturl;
				if (friendsadvertisinglogouturl) {
					this.appViewService.setLogoutReturnUrl(friendsadvertisinglogouturl);
				}
				else if (partnerAdvertisingData.productOverviewUrl) {
					this.appViewService.setLogoutReturnUrl(partnerAdvertisingData.productOverviewUrl);
				}
			}
		}

		this.loader.complete();
	}

}
